export const GOOGLEAUTHENTICATIONREQUEST = "GOOGLEAUTHENTICATIONREQUEST"
export const GOOGLEAUTHENTICATIONFAILURE = "GOOGLEAUTHENTICATIONFAILURE"
export const GOOGLEAUTHENTICATIONSUCCESS = "GOOGLEAUTHENTICATIONSUCCESS"
export const GOOGLECLIENTID = "394334137544-25s17akg1i6u2nd5cb5ucv3caca71n8k.apps.googleusercontent.com";